import React from 'react'
// libs
import { destroy } from 'redux-form'
import { useRouter } from 'hooks/useRouter'
import { useDispatch } from 'react-redux'
// components
import { Tab } from '@mui/material'
import TabMenu from './components/TabMenu'
import ConfirmDeleteModal from 'components/Modals/ConfirmDeleteModal'
// constants
import { Forms } from 'constants/forms'
//hooks
import { useFormsLinking } from 'hooks/risks'
// context
import { RiskViewAPIContext } from 'containers/Risks/RiskView/layers/API'
import { RiskRegisterContext } from 'containers/Risks/RisksRegister/layers'
// types
import { IFilter } from 'types/graphql'
// views
import { StyledTabs } from './views'

const RiskViewFilters: React.FC = () => {
  const router = useRouter()
  const dispatch = useDispatch()

  const { isLinking } = useFormsLinking()

  const { riskView } = React.useContext(RiskRegisterContext)
  const { filters, appliedFilters, setAppliedFilters, currentTab, setCurrentTab, setOrder } =
    React.useContext(RiskViewAPIContext)

  const currentRiskView = React.useRef(riskView?.id)

  const onTabClick = (filter: IFilter) => () => {
    if (currentTab === filter.id) {
      if (isLinking) {
        return
      }

      setOrder(null)
      setCurrentTab(null)
      setAppliedFilters(null)
      dispatch(destroy(Forms.RISK_VIEW_FILTER_FORM))
    } else {
      const { fieldFilters, order } = filter.args

      setCurrentTab(filter.id)
      setOrder(order || null)
      setAppliedFilters(fieldFilters, filter.id)
    }
  }

  // select first filter if nothing saved in localStorage
  React.useEffect(() => {
    if (router.query.riskId) {
      return
    }

    if (filters.length && (currentRiskView.current !== riskView.id || !appliedFilters)) {
      onTabClick(filters[0])()

      currentRiskView.current = riskView.id
    }
  }, [riskView?.id, filters, router.query.riskId])

  if (!filters.length) {
    return null
  }

  return (
    <StyledTabs textColor='primary' variant='scrollable' indicatorColor='primary' value={currentTab ?? false}>
      {filters.map((filter) => (
        <Tab
          key={filter.id}
          value={filter.id}
          label={filter.name}
          onClick={onTabClick(filter)}
          icon={isLinking ? null : <TabMenu filter={filter} />}
        />
      ))}
      <ConfirmDeleteModal header='Delete Filter'>Are you sure you want to delete this filter?</ConfirmDeleteModal>
    </StyledTabs>
  )
}

export default RiskViewFilters
